<template>
  <div class="main_content">
    <el-card style="min-height: 400px">
      <div slot="header" class="clearfix">
        <span>网红分类设置</span>
      </div>
      <el-row type="flex" justify="flex-start" :gutter="20">
        <el-col :span="6"
          ><div class="grid-content" @click="routerPush('/fbSetting')">
            <h1 class="display_flex align_item_center">
              <i class="iconfont icon-Facebook"></i>
              设置Facebook分类
            </h1>
            <p>将Facebook原有的分类调整到自定义的分类之下</p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content" @click="$router.push('/ttSetting')">
            <h1 class="display_flex align_item_center">
              <i class="iconfont icon-icon_TikTok"></i>
              设置TikTok分类
            </h1>
            <p>自定义TikTok下媒体达人的分类<br/>&nbsp;</p>
          </div></el-col
        >
        <el-col :span="6"></el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    }
  },
  methods: {
    routerPush(url) {
      console.log(url);
      this.$router.push({
        path: url
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.grid-content {
  border-radius: 4px;
  border: 1px solid #d7dae2;
  padding: 20px;
  height: 100px;
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.2s;
    cursor: pointer;
  }
  h1 {
    // font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    .iconfont {
      font-size: 24px;
      margin-right: 10px;
    }
    .icon-Facebook {
      color: rgb(66, 95, 155);
    }
    .icon-youtube1 {
      color: rgb(255, 0, 0);
    }
  }
  >p {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
  }
}
</style>